<template>
  <el-dialog
    :model-value="modelValue"
    class="post-detail-dialog"
    :class="{ 'is-mobile-fullscreen': isMobile }"
    title="帖子详情"
    :width="isMobile ? '100%' : '720px'"
    :fullscreen="isMobile"
    :top="isMobile ? '0' : '4vh'"
    :align-center="!isMobile"
    destroy-on-close
    append-to-body
    @update:model-value="$emit('update:modelValue', $event)"
    @closed="$emit('closed')"
  >
    <div v-loading="loading" class="post-detail-body">
      <PostFeedItem
        v-if="post"
        :key="post.id"
        :post="post"
        detail-mode
        @need-login="$emit('need-login')"
        @open-profile="onOpenProfile"
        @select-topic="onSelectTopic"
        @comment-count-change="onCommentCountChange"
        @deleted="onDeleted"
      />
      <el-empty v-else-if="!loading" description="帖子不存在或已删除" :image-size="72" />
    </div>
  </el-dialog>
</template>

<script>
import { getPostById } from "@/api/post";
import PostFeedItem from "@/components/post/PostFeedItem.vue";

const MOBILE_MQ = "(max-width: 768px)";

export default {
  name: "PostDetailDialog",
  components: { PostFeedItem },
  props: {
    modelValue: { type: Boolean, default: false },
    postId: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue", "closed", "need-login", "deleted"],
  data() {
    return {
      loading: false,
      post: null,
      isMobile: false,
    };
  },
  watch: {
    modelValue(visible) {
      if (visible) this.loadPost();
      else this.post = null;
    },
    postId() {
      if (this.modelValue) this.loadPost();
    },
  },
  mounted() {
    if (typeof window === "undefined" || !window.matchMedia) return;
    this.mediaQuery = window.matchMedia(MOBILE_MQ);
    this.isMobile = this.mediaQuery.matches;
    this.onMediaQueryChange = (e) => {
      this.isMobile = e.matches;
    };
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.onMediaQueryChange);
    } else {
      this.mediaQuery.addListener(this.onMediaQueryChange);
    }
  },
  beforeUnmount() {
    if (!this.mediaQuery || !this.onMediaQueryChange) return;
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener("change", this.onMediaQueryChange);
    } else {
      this.mediaQuery.removeListener(this.onMediaQueryChange);
    }
  },
  methods: {
    async loadPost() {
      const id = this.postId;
      if (id == null || id === "") {
        this.post = null;
        return;
      }
      this.loading = true;
      this.post = null;
      try {
        const res = await getPostById(id);
        if (res?.data?.code === 200) {
          this.post = res.data.data || null;
        } else {
          this.post = null;
        }
      } catch (e) {
        console.error("加载帖子详情失败:", e);
        this.post = null;
      } finally {
        this.loading = false;
      }
    },
    onOpenProfile(userId) {
      if (userId == null || userId === "") return;
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
    },
    onSelectTopic(topicId) {
      this.$emit("update:modelValue", false);
      this.$router.push({ path: "/", query: topicId != null ? { topicId } : {} });
    },
    onCommentCountChange(n) {
      if (this.post) this.post.commentCount = n;
    },
    onDeleted(postId) {
      this.$emit("deleted", postId);
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped>
.post-detail-body {
  min-height: 180px;
  max-height: min(78vh, 820px);
  overflow: auto;
  margin: 0 -4px;
  padding: 0 4px 8px;
}
</style>

<style>
.post-detail-dialog .el-dialog__body {
  padding-top: 8px;
  padding-bottom: 12px;
}

.post-detail-dialog .feed-item {
  margin-bottom: 0;
  padding: 4px 0 0;
  box-shadow: none;
  background: transparent;
}

.post-detail-dialog.is-mobile-fullscreen.el-dialog.is-fullscreen,
.post-detail-dialog.is-mobile-fullscreen.is-fullscreen {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  border-radius: 0;
}

.post-detail-dialog.is-mobile-fullscreen .el-dialog__header {
  flex-shrink: 0;
  padding: 12px 16px;
  margin-right: 0;
  border-bottom: 1px solid var(--el-border-color-lighter);
}

.post-detail-dialog.is-mobile-fullscreen .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 8px 12px calc(12px + env(safe-area-inset-bottom, 0px));
}

.post-detail-dialog.is-mobile-fullscreen .post-detail-body {
  flex: 1;
  min-height: 0;
  max-height: none;
  overflow: auto;
  margin: 0;
  padding: 0 0 8px;
  -webkit-overflow-scrolling: touch;
}
</style>
